/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { withLoading } from '@front-activerse/common-components';
import { useTranslator } from '@front-activerse/common-components';
import GoalHeader from './Goal/HydrationDayGoalHeader';
import Goal from './Goal/HydrationDayGoal';
import Progress from './Progress/HydrationDayProgress';
import Delete from './Delete/HydrationDayDelete';
import AddContainer from './Add/HydrationAddContainer';
import History from './History/HydrationHistory';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import Layout from '../../Layout/Layout';
import TitleBar from '../../Layout/TitleBar';
import { useOutletContext } from 'react-router-dom';

const HydrationDayContainer = ({
  date,
  goal,
  value,
  changeGoal,
  changeGoalMessages,
  hydrationSaveSettingsData,
  removeLastPortion = null,
  removeLastPortionMessages,
  add,
  messages,
  loading2,
  dateFrom,
  dateTo,
  unit = null,
  defaultDailyGoal = null,
  days = [],
  historyLength,
  setHistoryLength,
}) => {
  const { t } = useTranslator();
  const { trackFirebaseEvent } = useOutletContext();

  useEffect(() => {
    trackFirebaseEvent('screen_view', {
      firebase_screen: 'Hydration',
    });
  }, []);

  return (
    <Layout>
      <TitleBar showBackBtn={false}>{t('hydration.navbarTitle')}</TitleBar>
      <div className="page-template-hydration">
        <Container className="py-md-4">
          <Row>
            <Col md={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <div className="hydration-container">
                  <div className="hydration-box">
                    <Row>
                      <Col xl={{ size: 6, offset: 3 }}>
                        <GoalHeader unit={goal.unit} goal={goal.value} value={value} />
                        <Progress unit={goal.unit} goal={goal.value} value={value} />
                        <Goal
                          date={date}
                          unit={goal.unit}
                          goal={goal.value}
                          value={value}
                          changeGoal={changeGoal}
                          hydrationSaveSettingsData={hydrationSaveSettingsData}
                          messages={changeGoalMessages}
                        />
                        <AddContainer unit={goal.unit} messages={messages} add={add} />
                        <Delete
                          removeLastPortion={removeLastPortion}
                          messages={removeLastPortionMessages}
                        />
                      </Col>
                    </Row>
                  </div>
                  <History
                    historyLength={historyLength}
                    loading={loading2}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    unit={unit}
                    days={days}
                    defaultDailyGoal={defaultDailyGoal}
                    setHistoryLength={setHistoryLength}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

const Placeholder = () => <UniversalPlaceholder titleBar="hydration.navbarTitle" />;

export default withLoading(HydrationDayContainer, Placeholder);
